@use '../../scss/utility/functions' as utility;

$_radio-size: utility.wb-pixel-to-rem(24px);
$_spacing-label: utility.wb-pixel-to-rem(8px);

:host {
  --highlight-color: var(--wb-blue-45);
  --focus-color: var(--wb-blue-45);
  --error-color: var(--wb-red-45);
  --bg-color--hover: var(--wb-grey-85);

  display: block;
  position: relative;
}

:host([error]) input ~ .indicator {
  border-color: var(--error-color);
}

:host(:not([error]):not([disabled])) input:hover ~ .indicator {
  border-color: var(--highlight-color);
}

:host([disabled]) {
  opacity: 0.4;

  label {
    cursor: not-allowed;
  }

  input ~ .radio {
    cursor: not-allowed;
  }
}

label {
  display: inline-block;
  cursor: pointer;
  color: var(--wb-grey-20);
  padding-inline-start: $_radio-size + $_spacing-label;
}

input {
  width: $_radio-size;
  height: $_radio-size;
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  margin: 0;
  opacity: 0;
  padding: 0;
  z-index: -1;

  &:focus ~ .indicator {
    outline: utility.wb-pixel-to-rem(1px) solid var(--focus-color);
    outline-offset: utility.wb-pixel-to-rem(1px);
  }

  & ~ .indicator {
    display: block;
    width: $_radio-size;
    height: $_radio-size;
    background-color: var(--wb-grey-95);
    position: absolute;
    inset-block: 0;
    inset-inline: 0;
    border-radius: var(--wb-radius-full);
    border: utility.wb-pixel-to-rem(1px) solid var(--wb-grey-70);
    transition: border-width 0.3s var(--wb-move);
    box-sizing: border-box;
  }

  &:checked ~ .indicator {
    border-color: var(--highlight-color);
    border-width: utility.wb-pixel-to-rem(8px);
  }
}

input:hover ~ .indicator {
  background-color: var(--bg-color--hover);
}

::slotted(.wb-control-error),
::slotted(.wb-control-hint) {
  padding-inline-start: $_radio-size + $_spacing-label;
}

:host([theme='dark']) {
  --highlight-color: var(--wb-blue-50);
  --focus-color: var(--wb-blue-50);
  --error-color: var(--wb-red-50);
  --bg-color--hover: var(--wb-grey-25);

  label {
    color: var(--wb-white);
  }

  input {
    & ~ .indicator {
      background-color: var(--wb-grey-15);
      border: utility.wb-pixel-to-rem(1px) solid var(--wb-grey-40);
    }

    &:checked ~ .indicator {
      border-color: var(--highlight-color);
      background-color: var(--wb-white);
      border-width: utility.wb-pixel-to-rem(8px);
    }
  }
}

:host([theme='dark'][error]) input ~ .indicator {
  border-color: var(--error-color);
}

input,
label {
  -webkit-tap-highlight-color: transparent;
}
